const state = {
    role: [],
    loading: false
};

export default state;